<template>
  <div class="login-section">
    <div class="login-wrapper">
      <div class="bg" style="background-image: url('img/login/background-image.png')"></div>

      <div class="website-logo text-center">
        <img class="logo-big" src="img/login/logo-2.png" alt />
        <img class="logo-small" src="img/login/logo.png" alt />
      </div>

      <div class="login-content-wrapper">
        <div class="login-content">
          <div class="row">
            <div class="col-4">
              <span class="process-step" v-bind:class="checkStep('1')">&nbsp;</span>
            </div>
            <div class="col-4">
              <span class="process-step" v-bind:class="checkStep('2')">&nbsp;</span>
            </div>
            <div class="col-4">
              <span class="process-step" v-bind:class="checkStep('3')">&nbsp;</span>
            </div>
          </div>

          <section v-if="step === 1">
            <h4 class="w-medium">{{ $t('FORGOT.STEP1.TITLE') }}</h4>

            <div class="form-group row">
              <label class="col-form-label">{{ $t('FORGOT.STEP1.INPUT_EMAIL') }}</label>
              <input
                class="form-control"
                v-model="uniqueIdentifier"
                type="text"
                name="email"
                required
              />
            </div>

            <p class="mt-4">
              <button
                v-on:click="sendVerification"
                class="btn btn-fill btn-primary"
              >{{ $t('FORGOT.STEP1.NEXT') }}</button>
            </p>

            <div class="mt-4">
              <router-link :to="{ name: 'Login' }">{{ $t('FORGOT.STEP1.BACK')}}</router-link>
            </div>
          </section>

          <section v-if="step === 2">
            <h4 class="w-medium">{{ $t('FORGOT.STEP2.TITLE') }}</h4>
            <p class="w-medium">{{ $t('FORGOT.STEP2.INFORMATION') }}</p>

            <p class="w-medium">
              {{ $t('FORGOT.STEP2.INPUT_CODE')}}
              <input
                class="form-control verificationCode"
                type="number"
                autocomplete="off"
                v-model="verificationCode"
                ref="verification"
                @keypress="verifyCode"
              />
            </p>
            <h4 class="w-medium">{{ $t('FORGOT.STEP2.NO_CODE') }}</h4>
            <p>
              <button
                v-on:click="getNewVerificationCode"
                class="btn btn-fill btn-primary"
              >{{ $t('FORGOT.STEP2.GET_CODE') }}</button>
            </p>

            <div class="mt-4">
              <router-link :to="{ name: 'Login' }">{{ $t('FORGOT.STEP2.BACK')}}</router-link>
            </div>
          </section>

          <section v-if="step === 3">
            <h4 class="w-medium">{{ $t('FORGOT.STEP3.TITLE') }}</h4>

            <div class="form-group row">
              <label class="col-sm-4 col-form-label">{{ $t('FORGOT.STEP3.INPUT_PASSWORD') }}</label>
              <div class="col-sm-8">
                <input
                  class="form-control"
                  v-model="password"
                  type="password"
                  name="password1"
                  required
                />
              </div>
            </div>

             <p class="mt-4">
              <button
                v-on:click="setNewPassword"
                class="btn btn-fill btn-primary"
              >{{ $t('FORGOT.STEP3.NEXT') }}</button>
            </p>

            <div class="mt-4">
              <router-link v-on:click="gotoBack">{{ $t('FORGOT.STEP3.BACK')}}</router-link>
            </div>

          </section>

          <LocaleLogin></LocaleLogin>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LocaleLogin from "@/components/Layout/LocaleLogin";

export default {
  components: {
    LocaleLogin
  },
  data() {
    return {
      errorMessage: "",
      image: "img/login-image.png",
      uniqueIdentifier: "",
      verificationCode: "",
      password: "",
      step: 1
    };
  },
  methods: {
    checkStep: function(checkStep) {
      let result = [];
      if (checkStep == this.step) {
        result.push("active");
      }
      return result;
    },
    verifyCode($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
      if (this.verificationCode.length > 5) {
        $event.preventDefault();
      }
    },
    setFocus: function() {
      //this.$refs.verification.focus();
    },
    gotoBack: function() {
      this.step = 1;
      self.verificationCode = "";
    },
    sendVerification: function() {
      localStorage.setItem("uui", this.uniqueIdentifier);
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/forgot/get-verificationcode`, {
          email: this.uniqueIdentifier
        })
        .then(function() {
          self.step = 2;
          self.$noty.info(self.$t("FORGOT.SUCCESS.SENT_CODE"));
        })
        .catch(error => {
          self.step = 1;
          self.$noty.error(self.$t(error.response.data));
        });
    },
    getNewVerificationCode: function() {
      this.loading = true;
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/forgot/get-verificationcode`, {
          email: this.uniqueIdentifier
        })
        .then(function() {
          self.$noty.info(self.$t("FORGOT.SUCCESS.SENT_NEW_CODE"));
          self.verificationCode = "";
        })
        .catch(error => {
          2;
          self.$noty.error(self.$t(error.response.data));
        });
    },
    setNewPassword: function() {
      this.loading = true;
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/forgot/verify/new-password`, {
          verificationCode: this.verificationCode,
          password: this.password
        })
        .then(function() {
          self.$noty.info(self.$t("FORGOT.SUCCESS.SET_NEW_PASSWORD"));
          self.$router.push("login");
        })
        .catch(error => {
          self.$noty.error(self.$t(error.response.data));
        });
    },
    isFocused: function() {
      //setTimeout(self.setFocus(), 600);
    }
  },
  watch: {
    verificationCode: function() {
      if (this.verificationCode.length === 6) {
        let self = this;
        this.$http
          .post(process.env.VUE_APP_BACKEND + `/forgot/verify`, {
            verificationCode: this.verificationCode
          })
          .then(function() {
            self.step = 3;
          })
          .catch(error => {
            self.$noty.error(self.$t(error.response.data));
          });
      }
    }
  },
  created() {
    if (localStorage.getItem("uui") !== null) {
      this.uniqueIdentifier = localStorage.getItem("uui");
    }
    if (this.$route.query.code !== undefined) {
      this.invitationCode = this.$route.query.code;
      this.step = 2;
      //setTimeout(this.setFocus(), 600);
    }
    window.addEventListener("focus", this.isFocused);
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
</style>